import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import Appointment from '../sections/Appointment/Appointment';
import SEO from '../components/SEO';

const AppointmentPage = ({ lang = 'en' }) => {
  const BASE_URL = "https://alsaketdental.com";
  const SITE_NAME = "AlSaket Dental Clinics";
  const SITE_NAME_AR = "عيادات الساكت لطب الأسنان";

  const isArabic = lang === 'ar';
  const pageUrl = `${BASE_URL}/${lang}/appointment`;

  // JSON-LD: Appointment Page
  const appointmentPageLD = {
    "@context": "https://schema.org",
    "@type": "MedicalAppointment",
    "name": "Book Dental Appointment",
    "alternateName": "حجز موعد طبيب الأسنان",
    "url": pageUrl,
    "description": "Book your dental appointment easily with the best dentists in Amman via WhatsApp or direct call. Professional dental care scheduling.",
    "description_ar": "احجز موعدك بسهولة مع أفضل أطباء الأسنان في عمان عبر WhatsApp أو الاتصال المباشر. جدولة رعاية الأسنان المهنية.",
    "provider": {
      "@type": "Dentist",
      "name": "Dr. Yousef AlSaket",
      "alternateName": "دكتور يوسف الساكت",
      "telephone": "+962-79-2602666",
      "email": "info@alsaketdental.com"
    },
    "potentialAction": {
      "@type": "ScheduleAction",
      "name": "Book Appointment",
      "name_ar": "حجز موعد",
      "url": "https://api.whatsapp.com/send?phone=+962792602666&text=Hello%20doctor%20can%20I%20book%20an%20appointment?"
    },
    "availableChannel": [
      {
        "@type": "ServiceChannel",
        "serviceName": "WhatsApp Booking",
        "serviceName_ar": "حجز عبر WhatsApp",
        "serviceUrl": "https://api.whatsapp.com/send?phone=+962792602666"
      },
      {
        "@type": "ServiceChannel", 
        "serviceName": "Phone Booking",
        "serviceName_ar": "حجز عبر الهاتف",
        "serviceUrl": "tel:+962792602666"
      }
    ]
  };

  return (
    <>
      <SEO
        title="Book Dental Appointment - AlSaket Dental Clinics"
        titleAr="حجز موعد طبيب الأسنان - عيادات الساكت"
        description="Book your dental appointment easily with the best dentists in Amman, Jordan via WhatsApp or direct call. Professional dental care scheduling and consultation."
        descriptionAr="احجز موعدك بسهولة مع أفضل أطباء الأسنان في عمان، الأردن عبر WhatsApp أو الاتصال المباشر. جدولة رعاية الأسنان المهنية والاستشارة."
        keywords={[
          "book dental appointment amman", 
          "dentist appointment jordan", 
          "whatsapp dental booking amman", 
          "dental consultation amman",
          "schedule dentist visit jordan",
          "dental appointment booking amman",
          "emergency dentist amman",
          "dental care scheduling jordan"
        ]}
        keywordsAr={[
          "حجز موعد طبيب أسنان عمان", 
          "موعد طبيب الأسنان الأردن", 
          "حجز أسنان عبر WhatsApp عمان", 
          "استشارة طب الأسنان عمان",
          "جدولة زيارة طبيب الأسنان الأردن",
          "حجز موعد طب الأسنان عمان",
          "طبيب أسنان طوارئ عمان",
          "جدولة رعاية الأسنان الأردن"
        ]}
        url={pageUrl}
        image={`${BASE_URL}/images/appointment-og-image.jpg`}
        siteName={SITE_NAME}
        siteNameAr={SITE_NAME_AR}
        structuredData={[appointmentPageLD]}
        lang={isArabic ? 'ar' : 'en'}
      />
      
      <Navbar />
      <Appointment />
      <Footer />
    </>
  );
};

export default AppointmentPage;
